import './CardComponent.scss';
import { sanitiseHTML } from '../../../../../legacy/utils/helpers';
import { getPicture } from '../../../../../redux/services/commonServices';
import { useEffect, useState } from 'react';
import blueCheck from '../../../../../assets/icons/icon-checkmark-blue.svg';
import redCheck from '../../../../../assets/icons/icon-checkmark-red.svg';
import greenCheck from '../../../../../assets/icons/icon-checkmark-green copy.svg';
import purpleCheck from '../../../../../assets/icons/icon-checkmark-purple.svg';
import cyanCheck from '../../../../../assets/icons/icon-checkmark-cyan.svg';
import grayCheck from '../../../../../assets/icons/icon-checkmark-gray.svg';
import yellowCheck from '../../../../../assets/icons/icon-checkmark-yellow.svg';
import { generateRandomGradient } from 'src/latest/src/utils';

const IconPath = '/icons/';

const preloadSrcList = [
  blueCheck,
  redCheck,
  greenCheck,
  purpleCheck,
  cyanCheck,
  yellowCheck,
];

interface props {
  selected?: boolean;
  onChange?: Function;
  className?: string;
  choice?: any;
  isAddressInfoPage?: boolean;
  isAnySelected?: any;
}

const preloadImage = (src: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = function() {
      resolve(img);
    };

    img.onerror = img.onabort = function() {
      reject(src);
    };

    img.src = src;
  });
};

const CardComponent = ({
  selected,
  onChange,
  className,
  choice,
  isAddressInfoPage,
  isAnySelected,
}: props) => {
  // State to save updated base64 image string
  const [imageUri, setImageUri] = useState('');
  const [imageBackground, setImageBackground] = useState('');
  const [assetsLoaded, setAssetsLoaded] = useState(false);

  const metadata = choice?.metadata || {};
  const metaclassnames = metadata.class;

  const icon =
    metadata.icon?.split(',').map(i => {
      return IconPath + i;
    }) || [];
  const color = metadata?.color?.split(',') || [];

  const getBackground = (img, noOfIcons, iconIndex, icon) => {
    if (noOfIcons > 1 && iconIndex === 0) {
      switch (icon) {
        case '/icons/icon-in-person.svg': {
          return 'linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)';
        }

        default: {
          return 'linear-gradient(225deg, #26ECB0 0%, #0FCC93 100%), linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)';
        }
      }
    } else if (icon === '/icons/icon-skipIntake.svg') {
      return 'linear-gradient(225deg, #BDC2C8 0%, #929AA6 100%)';
    } else {
      switch (img) {
        case 'icon-checkmark-purple.svg': {
          return 'linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)';
        }

        case 'icon-checkmark-green.svg': {
          return 'linear-gradient(225deg, #26ECB0 0%, #0FCC93 100%), linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%';
        }

        case 'icon-checkmark-blue.svg': {
          return 'linear-gradient(225deg, #9EADFF 0%, #6C7BEA 100%)';
        }

        case 'icon-checkmark-cyan.svg': {
          return 'linear-gradient(225deg, #58DDE0 0%, #2FC5CA 100%)';
        }

        case 'icon-checkmark-red.svg': {
          return 'linear-gradient(225deg, #FF8F8F 0%, #DE5959 100%)';
        }

        case 'icon-checkmark-gray.svg': {
          return 'linear-gradient(225deg, #BDC2C8 0%, #929AA6 100%)';
        }

        case 'icon-checkmark-yellow.svg': {
          return 'linear-gradient(51.38deg, #F5BB33 18.26%, #FFCF5E 87.33%)';
        }

        default: {
          return '#fff';
        }
      }
    }
  };

  const getCheckMark = img => {
    switch (img) {
      case 'icon-checkmark-purple.svg': {
        return purpleCheck;
      }

      case 'icon-checkmark-green.svg': {
        return greenCheck;
      }

      case 'icon-checkmark-blue.svg': {
        return blueCheck;
      }

      case 'icon-checkmark-cyan.svg': {
        return cyanCheck;
      }

      case 'icon-checkmark-red.svg': {
        return redCheck;
      }

      case 'icon-checkmark-gray.svg': {
        return grayCheck;
      }

      case 'icon-checkmark-yellow.svg': {
        return yellowCheck;
      }

      default: {
        return greenCheck;
      }
    }
  };

  // useEffect for calling getImageUri()
  useEffect(async () => {
    if (isAddressInfoPage) {
      getImageUri(metadata?.img);
      setImageBackground(generateRandomGradient());
    }

    const imagesPromiseList: Promise<any>[] = [];

    for (const i of preloadSrcList) {
      imagesPromiseList.push(preloadImage(i));
    }

    await Promise.all(imagesPromiseList);

    setAssetsLoaded(true);
  }, []);

  // Getting the image
  const getImageUri = async id => {
    const imageData = await getPicture(id);

    // Sets the base64 string to state
    setImageUri(imageData);
  };

  return assetsLoaded && isAddressInfoPage ? (
    <div
      className={`card-component-ofc card-component ${className} ${
        selected ? 'active-ofc' : 'not-active-ofc'
      } ${metaclassnames || ''} `}
      onClick={() => onChange(!selected)}
    >
      <div className={`card-component__label-container-ofc`}>
        {metadata?.img && metadata?.img.includes('defaultofficepic.svg') ? (
          <label
            className="card-component__label"
            style={{
              background: imageBackground,
            }}
          >
            <img
              id="img"
              src={`${IconPath + 'defaultofficepic.svg'}`}
              alt="address"
              className={`card-component__img`}
            />
          </label>
        ) : (
          <label
            className="card-component__ofcImage card-component__label"
            style={{ background: `url(${imageUri})` }}
          />
        )}
      </div>
      {selected && (
        <div className={`card-component__checkmark`}>
          <img
            id="img"
            src={`${getCheckMark(metadata.checkMark)}`}
            alt="checkmark"
          />
        </div>
      )}
      {choice?.description && (
        <div className="card-component__ofcTitle card-component__info">
          {sanitiseHTML(choice?.description)}
        </div>
      )}

      <div className="card-component__ofcAddress">
        {metadata?.addressInfo1 && <p>{sanitiseHTML(metadata.addressInfo1)}</p>}
        {metadata?.addressInfo2 && <p>{sanitiseHTML(metadata.addressInfo2)}</p>}
        {metadata?.addressInfo3 && <p>{sanitiseHTML(metadata.addressInfo3)}</p>}
      </div>
    </div>
  ) : (
    assetsLoaded && (
      <div
        className={`card-component ${className} ${
          selected ? 'active-ofc' : isAnySelected ? 'not-active-ofc' : ''
        } ${metaclassnames || ''}`}
        onClick={() => onChange(!selected)}
      >
        <div
          className={`card-component__label-container ${
            color?.length === 2 ? 'multiple' : ''
          }`}
        >
          {color &&
            color.map((c, i) => (
              <label
                className="card-component__label"
                style={{
                  background: getBackground(
                    metadata?.checkMark,
                    icon?.length,
                    i,
                    icon[i],
                  ),
                }}
              >
                <img
                  id="img"
                  src={icon[i]}
                  alt="user"
                  className={`card-component__img ${icon[i]
                    .replace('.svg', '')
                    .replace('/icons/', '')} ${metadata?.classNames || ''} `}
                />
              </label>
            ))}
        </div>
        {selected && (
          <div
            className={`card-component__checkmark ${
              color?.length === 2 ? 'multiple' : ''
            }`}
          >
            <img
              id="img"
              src={`${getCheckMark(metadata.checkMark)}`}
              alt="checkmark"
            />
          </div>
        )}
        {choice?.title && (
          <div className="card-component__info">
            {sanitiseHTML(choice?.title)}
          </div>
        )}

        {choice?.description && (
          <div className="card-component__description">
            {sanitiseHTML(choice?.description)}
          </div>
        )}
      </div>
    )
  );
};

export default CardComponent;
